import React, { useContext } from "react";
import DisSkipSign from "./skipsign";
import { UserContext } from "../../context/userContext";
import { useNavigate } from "react-router-dom";

export default function DisSkipSignRoute(): React.JSX.Element {
  const navigate = useNavigate();
  const goToApp = () => {
    navigate("/");
  };

  const goToLogin = () => {
    navigate("/login");
  };

  const { email } = useContext(UserContext);
  const goNext = email ? goToApp : goToLogin;

  const renderComponent = () => {
    return <DisSkipSign next={goNext} loggedIn={!!email} />;
  };

  return renderComponent();
}
